import { Component } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../../../Services/BuissnessLogic/auth.service';
import {ColorScssService} from '../../../../shared/service/color-scss.service';
import {CheckoutHelperService} from '../../../../Services/BuissnessLogic/Checkout/checkout-helper.service';

@Component({
  selector: 'app-thank-you-for-order-paypal',
  standalone: true,
  imports: [],
  templateUrl: './thank-you-for-order-paypal.component.html',
  styleUrl: './thank-you-for-order-paypal.component.scss'
})
export class ThankYouForOrderPaypalComponent {
  email: string = ""
  constructor(private router: Router,
              private auth: AuthService,
              private color: ColorScssService,
              private checkoutHelper: CheckoutHelperService,

  ) {
    color.resetColorScheme()
    this.email = this.checkoutHelper.currentOrder.customer.email
  }
  onCreateAccount() {
    this.router.navigate(['/registrieren']);
  }
}
